import { createAction, props } from '@ngrx/store';
import { IScoreCardSkuResponse } from '@shared/data-access/interfaces';

export const scoreCardEligibilitySkuLoadedSuccess = createAction(
  '[PDP Product Container] Scorecard Eligibility Loaded Success',
  props<{ skuData: IScoreCardSkuResponse[] }>(),
);
